import React, { Component } from 'react';
import {
    Row, Col, TabContent, TabPane, Nav, NavItem,
    NavLink, Container
} from 'reactstrap'
import classnames from 'classnames';
import './AppointementsSideMenu.css'
import NotAppoint from '../../../assets/Images/NotFound/mawa3ed.png'
import String from '../../../assets/Locales/teacher_locales'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoginRequest, IntializeToken } from '../../../redux/Action/Auth/LoginAction'
import axios from 'axios'
import { API_ENDPOINT } from '../../../AppConfig'
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import Lottie from 'react-lottie';
import animationData from '../../../components/lotties/teacherAppointment.json'
import animationDataSTU from '../../../components/lotties/studentApp.json'
import animationDataAss from '../../../components/lotties/assApp.json'
import animationDataParent from '../../../components/lotties/parentApp.json'
class AppointementsSideMenu extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '0',
            getDay: '',
            alldates: [],
            currentDay: '',
            footer: false,
            noApp: false,
            noAppVisiitor: false,
            positionFooter: false,
            isStopped: false,
            isPaused: false,
            examsDates: [],
            extraLecturesDates: [],
            groupsDates: [],
            timing: null
        };
    }

    componentWillMount() {
        let d = new Date();
        let n = d.getDay();
        this.setState({ getDay: n, activeTab: 0 })
        var date = new Date().getDate(); //Current Date
        var month = new Date().getMonth() + 1; //Current Month
        var year = new Date().getFullYear(); //Current Year
        this.setState({ date: date + '-' + month + '-' + year })
        let type = this.props.userType
        if (type !== "VISITOR") {
            if (type === 'GUARDIAN' && this.props.user.student.length === 0) {
                this.setState({ noAppVisiitor: true, noApp: true })
            } else {
                this.fetchClander(date);
            }
        }
        else {
            this.setState({ noAppVisiitor: true, noApp: true })
        }
    }
    fetchClander = (date) => {
        this.props.showLoading()
        let month = new Date().getMonth() + 1,
            year = new Date().getFullYear(),
            url = '',
            Id = null,
            type = this.props.userType;
        if (type === 'ASSISTANT') {
            let techId = this.props.user.teacher.id;
            Id = this.props.user.id
            url = `${API_ENDPOINT}/groups/calender?assistant=${Id}&teacher=${techId}&month=${month}&year=${year}&day=${date}`
        }
        if (type === 'STUDENT') {
            Id = this.props.user.id
            url = `${API_ENDPOINT}/groups/calender?student=${Id}&month=${month}&year=${year}&day=${date}`
        }
        if (type === 'TEACHER') {
            Id = this.props.user.id
            url = `${API_ENDPOINT}/groups/calender?teacher=${Id}&month=${month}&year=${year}&day=${date}`
        }
        if (type === 'GUARDIAN') {
            let studId = this.props.activStudent ? this.props.activStudent.student.id : -1;
            Id = this.props.user.id
            url = `${API_ENDPOINT}/groups/calender?parent=${Id}&student=${studId}&month=${month}&year=${year}&day=${date}`
        }
        let token = `Bearer ${this.props.token}`
        axios.get(url, {
            headers: {
                "Accept-Language": this.props.lang,
                Authorization: token
            }
        }).then(response => {
            this.setState({ currentDay: date, noApp: true, alldates: type !== 'VISITOR' ? response.data.calender : this.state.alldates })
            this.props.hideLoading()
            if (response.data.calender.length > 1 || response.data.calender[0].groups.length > 1 ||
                response.data.calender[0].exams.length > 1 || response.data.calender[0].extraLectures.length > 1) {
                this.setState({ footer: true, positionFooter: true })
            }
        }).catch(err => {
            this.props.hideLoading()
        })
    }
    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    formateTime(time) {
        const fromDate = time;
        let checkFrom = `0${new Date(fromDate).getHours() - 1}`.slice(-2);
        let hoursfrom = `0${new Date(fromDate).getHours() - 1}`.slice(-2);
        hoursfrom = hoursfrom > 12 ? hoursfrom - 13 : hoursfrom
        const minutesfrom = `0${new Date(fromDate).getMinutes()}`.slice(-2);
        let minutesfromfinal = checkFrom > 12 ? minutesfrom + '' + String.evening : minutesfrom + ' ' + String.morning
        const newFrom = `${hoursfrom}:${minutesfromfinal}`
        return (newFrom)
    }
    render() {
        String.setLanguage(this.props.lang)
        let lang = this.props.lang
        var date = new Date().getDate(); //Current Date
        let days = [String.Sunday, String.Monday,
        String.Tuesday, String.Wednesday, String.Thursday, String.Friday, String.Saturday,], type = this.props.userType
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: type === "TEACHER" ? animationData : type === "ASSISTANT" ? animationDataAss : type === "GUARDIAN" ? animationDataParent : animationDataSTU,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return (
            <div>
                <div className="Dates py-5"
                    style={{
                        direction: this.props.lang === 'ar' ? 'rtl' : 'ltr',
                        textAlign: this.props.lang === 'ar' ? 'right' : 'left'
                    }}>
                    <Row className="m-0 ">
                        <Col lg="12" className="p-0 mb-2">
                            <Row>
                                <Col className={this.props.lang === "en" ? "text-left" : "text-right"}>
                                    <h4>{String.Dates}</h4>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg="12" className="p-0">
                            <Nav tabs className="p-0 ">
                                {days.map((day, element) => {
                                    return (
                                        <NavItem id={type === 'TEACHER' ? "navTeacher" : type === 'ASSISTANT' ? "navAssistant" : type === 'GUARDIAN' ? "navParent" : "navStudent"}>
                                            <NavLink
                                                style={{
                                                    padding: this.props.lang === "en" ? "8px 5px" : "8px 5px",
                                                    fontSize: this.props.lang === "en" ? "14px" : "14px",
                                                    borderBottom: type === 'TEACHER' && this.state.activeTab === element ? "3px solid #FFC85D" : type === 'ASSISTANT' && this.state.activeTab === element ? "3px solid #182B8B" : type === 'STUDENT' && this.state.activeTab === element ? "3px solid #009E2A" : type === 'PARENT' && this.state.activeTab === element ? "3px solid #37BBAE" : ""
                                                }}
                                                className={classnames({ active: this.state.activeTab === element })}
                                                onClick={() => {
                                                    this.toggle(element);
                                                    this.setState({ alldates: [], footer: false, noApp: false })
                                                    { type !== "VISITOR" ? this.fetchClander(date + element) : this.setState({ noAppVisiitor: true, noApp: true }) }
                                                }} >
                                                {element === 0 ? String.day : element <= 6 ?
                                                    (element + this.state.getDay) > 6 ?
                                                        days[(element + this.state.getDay) - 7] : days[element + this.state.getDay] : ""}
                                            </NavLink>
                                        </NavItem>
                                    )
                                })}
                            </Nav>
                        </Col>
                    </Row>
                    <TabContent activeTab={this.state.activeTab}>
                        {days.map((day, element) => {
                            return (
                                <TabPane tabId={element} className = "CONTAINER">
                                    <Container>
                                        {this.state.alldates.length > 0 && (this.state.alldates[0].groups.length > 0 || this.state.alldates[0].exams.length > 0 || this.state.alldates[0].extraLectures.length > 0) ?
                                            <Row style={{overflow: "auto", overflowX: "hidden" }}>
                                                {this.state.alldates.map((date) => {
                                                    return (
                                                        <div>
                                                            {date.groups.length > 0 && date.groups.map((group, ind) => (
                                                                <Col sm="12" className="tabcontent orange">
                                                                    <Row>
                                                                        <Col>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }} className="fa fa-map-marker-alt"></i></span> {group.address} </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }} className="fa fa-clock"></i></span>
                                                                                <span> {group.from && this.formateTime(group.from)}</span>-
                                                                               <span> {group.to && this.formateTime(group.to)}</span>
                                                                            </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }} className="fa fa-graduation-cap"></i></span> {lang === 'ar' ? group.teacherSubLevelSubject.teacherSubLevel.subLevel.name.ar : group.teacherSubLevelSubject.teacherSubLevel.subLevel.name.en} </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }} className="fa fa-book"></i></span> {lang === 'ar' ? group.teacherSubLevelSubject.subject.name.ar : group.teacherSubLevelSubject.subject.name.en} </p>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            ))}
                                                            {date.exams.length > 0 && date.exams.map((group, ind) => (
                                                                <Col sm="12" className="tabcontent">
                                                                    <Col>
                                                                    </Col>
                                                                    <Row>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FF5E5E" : type === 'ASSISTANT' ? "#484848" : type === 'STUDENT' ? "#484848" : "#484848" }} className="fa fa-map-marker-alt"></i></span> {group.address} </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FF5E5E" : type === 'ASSISTANT' ? "#484848" : type === 'STUDENT' ? "#484848" : "#484848" }} className="fa fa-clock"></i></span>
                                                                                <span> {group.from && this.formateTime(group.from)}</span>-
                                                                               <span> {group.to && this.formateTime(group.to)}</span>
                                                                            </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FF5E5E" : type === 'ASSISTANT' ? "#484848" : type === 'STUDENT' ? "#484848" : "#484848" }} className="fa fa-graduation-cap"></i></span> {lang === 'ar' ? group.teacherSubLevelSubject.teacherSubLevel.subLevel.name.ar : group.teacherSubLevelSubject.teacherSubLevel.subLevel.name.en} </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span className="icone-container" style={{ paddingLeft: this.props.lang === "ar" ? "5px" : "", paddingRight: this.props.lang === "en" ? "5px" : "" }}><i style={{ backgroundColor: type === 'TEACHER' ? "#FF5E5E" : type === 'ASSISTANT' ? "#484848" : type === 'STUDENT' ? "#484848" : "#484848" }} className="fa fa-book"></i></span> {lang === 'ar' ? group.teacherSubLevelSubject.subject.name.ar : group.teacherSubLevelSubject.subject.name.en} </p>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            ))}
                                                            {date.extraLectures.length > 0 && date.extraLectures.map((group, ind) => (
                                                                <Col sm="12" className="tabcontent ">
                                                                    <Row>
                                                                        <Col sm="12">
                                                                            <p> <span><i className="fa fa-map-marker-alt" style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }} ></i></span> {group.address} </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span><i className="fa fa-clock" style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }}></i></span>
                                                                                {/* {group.from > 12 ? group.from - 12 : group.from} {group.from > 12 ? String.evening : String.morning} - {group.to > 12 ? group.to - 12 : group.to} {group.to > 12 ? String.evening : String.morning} */}
                                                                                {/* {group.from}-{group.to} */}
                                                                                <span> {group.from && this.formateTime(group.extraLectures[0].from)}</span>-
                                                                               <span> {group.to && this.formateTime(group.extraLectures[0].to)}</span>
                                                                            </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span><i className="fa fa-graduation-cap" style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }}></i></span> {lang === 'ar' ? group.teacherSubLevelSubject.teacherSubLevel.subLevel.name.ar : group.teacherSubLevelSubject.teacherSubLevel.subLevel.name.en} </p>
                                                                        </Col>
                                                                        <Col sm="12">
                                                                            <p> <span><i className="fa fa-book" style={{ backgroundColor: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : "#37BBAE" }}></i></span> {lang === 'ar' ? group.teacherSubLevelSubject.subject.name.ar : group.teacherSubLevelSubject.subject.name.en} </p>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            ))}
                                                        </div>
                                                    )
                                                })}
                                            </Row>
                                            : this.props.userType !== "VISITOR" ?
                                                <Row>
                                                    {this.state.noApp ?
                                                        <div className="not-appoint">
                                                            <img src={NotAppoint} alt="No appointments" />
                                                            <p style={{ color: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : type === 'GUARDIAN' ? "#37BBAE" : "#009E2A" }} className="appointment-notexist">{String.noAppoint}</p>
                                                        </div>
                                                        : <div className="w-100 text-center" style={{ marginTop: "20%" }}>
                                                            <Lottie options={defaultOptions}
                                                                height="80%"
                                                                width="70%"
                                                                isStopped={this.state.isStopped}
                                                                isPaused={this.state.isPaused} />
                                                        </div>
                                                    }
                                                </Row> :
                                                <div className="not-appoint">
                                                    <img src={NotAppoint} alt="No appointments" />
                                                    <p style={{ color: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : type === 'GUARDIAN' ? "#37BBAE" : "#009E2A" }} className="appointment-notexist">{String.noAppoint}</p>
                                                </div>
                                        }
                                    </Container>
                                </TabPane>
                            )
                        })}
                        <Col sm="12" className="appointment-footer py-1">
                            <Row>
                                <Col className="p-0">
                                    <p><span><i style={{ color: type === 'TEACHER' ? "#FFC85D" : type === 'ASSISTANT' ? "#182B8B" : type === 'STUDENT' ? "#009E2A" : type === 'GUARDIAN' ? "#37BBAE" : "#009E2A" }} className="fa fa-baseball-ball"></i></span> {String.lectApp} </p>
                                </Col>
                                <Col className="p-0">
                                    <p> <span><i style={{ color: type === 'TEACHER' ? "#FF5E5E" : type === 'ASSISTANT' ? "#484848" : type === 'STUDENT' ? "#484848" : type === 'GUARDIAN' ? "#484848" : "#484848" }} className="fa fa-baseball-ball"></i></span> {String.examApp} </p>
                                </Col>
                            </Row>
                        </Col>
                    </TabContent>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        userType: state.login.userType,
        lang: state.lang.lang,
        token: state.login.token,
        user: state.login.user,
        activStudent: state.login.activeStudent
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        LoginRequest,
        IntializeToken,
        showLoading,
        hideLoading
    }
    , dispatch
)
export default (connect(mapStateToProps, mapDispatchToProps)(AppointementsSideMenu));